module.exports = __webpack_public_path__ + "img/doodle.805d2404.png";